const initialize = () => {
//configuration
    //shorthand for queryselector
    function qs(selector) {
        return document.querySelector(selector);
    }

    //copied from vendor/inbox/mailsync-model/src/Entity/MailSyncServer.php
    var SERVER_TYPE_GMAIL_LEGACY = 7; //when enabled "Less secure apps", can import multiple mailboxes
    var SERVER_TYPE_GMAIL_OAUTH2 = 8; //for @gmail.com and G-Suite/Workspace with oauth2 web login (one mailbox at a time can be added)
    var SERVER_TYPE_GOOGLE_SERVICE = 9; //with service account .json key to import whole domain
    var GOOGLE_SERVER_TYPES = [SERVER_TYPE_GMAIL_LEGACY, SERVER_TYPE_GMAIL_OAUTH2, SERVER_TYPE_GOOGLE_SERVICE];

    var SERVER_TYPE_EXCHANGE = 3;
    //microsoft new
    var SERVER_TYPE_OFFICE_365 = 4;
    var MICROSOFT_SERVER_TYPES = [SERVER_TYPE_EXCHANGE, SERVER_TYPE_OFFICE_365];

    var defaultGoogleDomains = ['gmail.com', 'googlemail.com'];

    var syncCfg = JSON.parse(qs('#mail-sync-cfg').dataset.cfg);

    var FORM_TYPE_SYNC_ONE = 'sync_one';
    //var FORM_TYPE_SYNC_MULTIPLE = 'sync_multiple';
    var FORM_TYPE_ONLY_CREATE = 'only_create';
    const selectedFormType =syncCfg.formType;
    // console.log('form type: ' + selectedFormType);

    var skipSyncEl = qs('#skipSync');
    if (skipSyncEl) {
        skipSyncEl.checked = selectedFormType === FORM_TYPE_ONLY_CREATE;
    }
    // document.querySelectorAll('.multiple-user-container').forEach(item => { item.classList.toggle('invisible', selectedFormType === FORM_TYPE_SYNC_ONE) });

    function checkSubmitBtn()
    {
        if (document.querySelectorAll('div[id^="mailSyncUsers_"]').length === 0) {
            //hide continue button if no users provided (social google case)
            qs('#submit').classList.add('invisible');
        } else {
            //show continue button
            qs('#submit').classList.remove('invisible');
        }
    }

    // // add-collection-widget.js
    // document.addEventListener("DOMContentLoaded", function() {
    function addMailbox(prototypeSelector, username, withDeleteButton=true, originDomainName, forename, surname, password, socialCredentials, isSocial) {
        var list = qs(prototypeSelector);
        if (!list) {
            return;
        }
        // Try to find the counter of the list or use the length of the list
        // var counter = list.data('widget-counter') || list.children().length;
        var counter = list.getAttribute('data-widget-counter') || list.children.length;
        // grab the prototype template
        var newWidget = list.getAttribute('data-prototype');
        // replace the "__name__" used in the id and name of the prototype
        // with a number that's unique to your emails
        // end name attribute looks like name="contact[emails][2]"
        newWidget = newWidget.replace(/__name__/g, counter);
        // Increase the counter
        counter++;
        // And store it, the length cannot be used if deleting widgets is allowed
        list.setAttribute('data-widget-counter', counter);

        // create a new list element and add it to the list
        var newElem = document.createElement('div');
        newElem.classList.add('form-row-container');
        newElem.innerHTML = newWidget.trim();
        newElem.firstElementChild.classList.add('form-row');

        //add email addon
        if (syncCfg.formType !== FORM_TYPE_SYNC_ONE) {
            //add email addon
            var addon = document.createElement('div');
            addon.classList.add('input-group');
            addon.innerHTML =
                newElem.querySelector('[name*="originUsername"]').outerHTML + //input g
                '<span aria-hidden="true" class="input-group-text glyphicon gl-at" style="padding-top:3px;padding-bottom:3px">@'+(originDomainName ? originDomainName : syncCfg.currentDomain)+
                '</span>';
            //move username input to input-group div
            var el= newElem.querySelector('[name*="originUsername"]');
            el.parentNode.append(addon);
            el.remove();
        }

        if (username) {
            newElem.querySelector('[name*="originUsername"]').value = username;
            if (isSocial) {
                newElem.querySelector('[name*="originUsername"]').readOnly = true;
            }
        }
        if (forename) {
            newElem.querySelector('[name*="forename"]').value = forename;
        }
        if (surname) {
            newElem.querySelector('[name*="surname"]').value = surname;
        }
        if (originDomainName && newElem.querySelector('[name*="originDomainName"]')) {
            newElem.querySelector('[name*="originDomainName"]').value = originDomainName;
        }
        if (password) {
            newElem.querySelector('[name*="password"]').value = typeof password === 'object' ? JSON.stringify(password) : password;
        }
        if (isSocial && socialCredentials) {
            newElem.querySelector('[name*="socialCredentials"]').value = typeof socialCredentials === 'object' ? JSON.stringify(socialCredentials) : socialCredentials;

            const passLabel = newElem.querySelector('[name*="password"]').parentNode.querySelector('label');
            if (passLabel) {
                passLabel.textContent = syncCfg.i18n.new_password;
            }
        }

        if (newElem.querySelector('[name*="isSocial"]')) {
            newElem.querySelector('[name*="isSocial"]').value = isSocial;
        }
        //webmail user can not create mailbxoes so we hide forename surname fields and add button
        const email = username + '@' + originDomainName;
        if (!syncCfg.formType === FORM_TYPE_SYNC_ONE) {
            if (isSocial) {
                var socialUsersWrapperEl = qs('#socialUsers');
                socialUsersWrapperEl.style.display = 'block';
                var socialUserEl = document.createElement('span');
                socialUserEl.classList.add('font-weight-bold');
                socialUserEl.innerHTML = syncCfg.i18n.account + ': ' + email + (isSocial ? ' (social) ' : '');
                socialUsersWrapperEl.append(socialUserEl);
            }
            var inputsToHide = document.querySelectorAll('#mailSyncUsers [name*="[forename]"],#mailSyncUsers [name*="[surname]"]');
            for(var inputToHide of inputsToHide) {
                inputToHide.parentElement.style.display = 'none';
            }
        } else {
            //
        }
        if (withDeleteButton) {

            //JS delete
            //add delete row link
            var deleteEl = document.createElement('div');
            deleteEl.classList.add('form-group');
            deleteEl.classList.add('p-2');

            var deleteLink = isSocial ? document.createElement('button') : document.createElement('a');
            if (isSocial) {
                //call actual hidden http post form outside of main form (form in a form is not allowed)
                deleteLink.setAttribute('form', 'social-delete-' + email);
            } else {
                //just delete html for non-social accounts
                deleteLink.classList.add('row-delete');
            }
            deleteLink.classList.add('btn');
            deleteLink.classList.add('btn-link');
            deleteLink.setAttribute('style', 'display:flex; color: #CC0917; margin-top: 0.3rem');

            deleteLink.innerHTML = '<span title="' + syncCfg.i18n.remove + '" style="font-size: 1.4em"><i class="fa fa-trash ifi-trash pr-0 pe-0" aria-hidden="true"/></span>';

            deleteEl.append(deleteLink);
            if (syncCfg.formType !== FORM_TYPE_SYNC_ONE) {
                newElem.querySelector('.form-row').append(deleteEl);
            } else {
                deleteLink.innerHTML = deleteLink.innerHTML + ' ' + syncCfg.i18n.remove;
                qs('.submitWrapper').append(deleteLink);
            }
        }

        list.appendChild(newElem);

        checkSubmitBtn();
    }

    //only used for google oauth2 / google service account in backend, should not be selectable by user visually
    if (qs('[name="authentication"][value="xoauth2"]')) {
        qs('[name="authentication"][value="xoauth2"]').parentNode.classList.add('invisible');
    }

    if (!syncCfg.hasSocial) {
        addMailbox('#mailSyncUsers', syncCfg.username, syncCfg.formType !== FORM_TYPE_SYNC_ONE);
    } else {
        for (const socialUserEmail in syncCfg.socialUsers) {
            const socialUser = syncCfg.socialUsers[socialUserEmail];
            const emailParts = socialUserEmail.split('@');
            addMailbox('#mailSyncUsers', emailParts[0], true, emailParts[1], socialUser.first_name, socialUser.last_name, '', socialUser.credentials, true);
        }

        qs('#host').readOnly = true;
        qs('#port').readOnly = true;

        // //hide skip sync option if social import started
        // if (syncCfg.socialUsers) {
        //     if (qs('#skip-sync-title')) {
        //         qs('#skip-sync-title').classList.add('invisible');
        //         qs('#skip-sync-content').classList.add('invisible');
        //     }
        // }
    }

    document.addEventListener('click', function (event) {
        // console.log(['clicked', event.target]);
        // If the clicked element doesn't have the right selector, bail
        var deleteLink = event.target.closest('.row-delete');
        if (!deleteLink) return;

        // Don't follow the link
        event.preventDefault();

        var rowToDelete = deleteLink.closest('.form-row');
        rowToDelete.parentNode.removeChild(rowToDelete);
    }, false);


    if (!window.addUserEventRegistered) {
        document.addEventListener('click', function (event) {
            window.addUserEventRegistered = true;
            // If the clicked element doesn't have the right selector, bail
            if (!event.target.matches('.add-another-collection-widget')) return;
            // Don't follow the link
            event.preventDefault();
            addMailbox('#mailSyncUsers', null, true);
        }, false);
    }



    //bootstrap4 needs JS to show filename as label on upload
    document.addEventListener('change', function (event) {
        // If the clicked element doesn't have the right selector, bail
        if (!event.target.matches('#mailSyncUsersCsv')) return;

        if (event.target.value) {
            var fullPath = event.target.value;
            var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
            var filename = fullPath.substring(startIndex);
            if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
                filename = filename.substring(1);
            }
            if (qs('.custom-file-label')) {
                qs('.custom-file-label').textContent = filename;
            }
        }

    }, false);


    // $('#inputGroupFile02').on('change',function(){
    //     //get the file name
    //     var fileName = $(this).val();
    //     //replace the "Choose a file" label
    //     $(this).next('.custom-file-label').html(fileName);
    // });

    function onPop3EnabledChange(pop3Checkbox, enabled) {
        const userRow = pop3Checkbox.parentNode.parentNode.parentNode;
        const pop3PasswordField = userRow.querySelector('input[name*="[pop3Password]"]');
        if (!pop3Checkbox.checked) {
            pop3PasswordField.value = '';
        }
        pop3PasswordField.readOnly = !pop3Checkbox.checked;
    }

    document.addEventListener('input', function (event) {
        if (!event.target.name.includes('pop3Enabled')) return;

        onPop3EnabledChange(event.target);
    }, false);

    function onSyncTypeChange(newSyncType) {
        // console.log('onsyncTypeChange called with newSyncType='+newSyncType);

        var reqInputs = '#mailSyncUsers input[name*="[targetUsername]"],#mailSyncUsers input[name*="[originUsername]' +
            '"],#mailSyncUsers input[name*="[password]"],#mailSyncUsers input[name*="[mailboxStatus]"]';

        if (newSyncType === 'csv') {
            qs('.mail-sync-users-csv').setAttribute('style', 'display:flex !important');
            qs('.mail-sync-users-manual').setAttribute('style', 'display:none !important');
            if (qs('.add-another-collection-widget')) {
                qs('.add-another-collection-widget').setAttribute('style', 'display:none !important');
            }
            //make inputs optional
            var requiredFields = document.querySelectorAll(reqInputs);
            for(var requiredField of requiredFields) {
                requiredField.required = false;
            }
        } else {
            if (qs('.mail-sync-users-csv')) {
                qs('.mail-sync-users-csv').setAttribute('style', 'display:none !important');
            }
            if (qs('.mail-sync-users-manual')) {
                qs('.mail-sync-users-manual').setAttribute('style', 'display:block !important');
            }
            if (qs('.add-another-collection-widget')) {
                qs('.add-another-collection-widget').setAttribute('style', 'display:inline-flex !important');
            }

            //make inputs required
            requiredFields = document.querySelectorAll(reqInputs);
            for(requiredField of requiredFields) {
                requiredField.required = true;
            }
        }
    }

    //on page load :checked somehow does not work as expected
    onSyncTypeChange(qs('[name="mailSyncUserType"]:checked,[name="mailSyncUserType"][checked="checked"],[name="mailSyncUserType"][type="hidden"]').value);
    //on radio input change: switch between user import type
    document.addEventListener('input', function (event) {
        var allowedTargets = ['mailSyncUserType'];
        if (!allowedTargets.includes(event.target.name)) return;

        onSyncTypeChange(event.target.value);
    }, false);

    function checkGoogleServiceType() {
        var originDomainName = qs('#originDomainName').value;
        // const defaultGoogleDomains = ['gmail.com', 'googlemail.com'];

        //for social server type is hidden and not radio
        if (!qs('[name="serverType"][value="'+SERVER_TYPE_GOOGLE_SERVICE+'"]')) {
            return;
        }
        if (defaultGoogleDomains.includes(originDomainName)) {
            qs('[name="serverType"][value="'+SERVER_TYPE_GOOGLE_SERVICE+'"]').disabled = true;
        } else {
            qs('[name="serverType"][value="'+SERVER_TYPE_GOOGLE_SERVICE+'"]').disabled = false;
        }
    }

    function enableWebAuth(enableOauth2)
    {
        // console.log('enableWebAuth called with enableOauth2='+enableOauth2);
        document.querySelectorAll('.hide-for-social').forEach(function(rowItem) {

            let cssDisplay = 'flex';
            if (rowItem.classList.contains('connection-configuration')) {
                cssDisplay = 'block';
            }

            //if mailSyncUserType is manual then we do not want show csv contents
            if (rowItem.classList.contains('mail-sync-users-csv')) {
                const selectedUserType = qs('[name="mailSyncUserType"]:checked');
                if (selectedUserType) {
                    cssDisplay = selectedUserType.value === 'csv' ? 'flex' : 'none';
                }
            }

            rowItem.setAttribute('style', 'display: ' + (enableOauth2 ? 'none' : cssDisplay) + ' !important');
        });

        //todo if socialUsers is 0 make submit button disabled
        const formSubmitBtn = qs('button[form="mail-sync-form"]');
        if (enableOauth2) {
            if (syncCfg.hasSocial) {
                formSubmitBtn.disabled = false;
            } else {
                formSubmitBtn.disabled = true;
            }
            if (qs('#add-google-account')) {
                qs('#add-google-account').style.display = 'inline-flex';
            }
        } else {
            if (qs('#add-google-account')) {
                qs('#add-google-account').style.display = 'none';
            }
            formSubmitBtn.disabled = false;
        }
    }

    function switchElementTagName(currElement, newTagName, additionalAttrs) {

        if (currElement.tagName === newTagName) {
            return;
        }

        const currElParent = currElement.parentNode;
        const currElLabel = currElParent.querySelector('label');

        let newEl = document.createElement(newTagName);
        // Copy the attributes to object for later user
        let attrs = {};
        for (var i = 0; i < currElement.attributes.length; i++) {
            attrs[currElement.attributes[i].name] = currElement.attributes[i].value;
        }

        //remove old element
        currElParent.removeChild(currElement);

        //copy all attributes from old input
        for (const [key, value] of Object.entries(attrs)) {
            newEl.setAttribute(key, value);
        }
        //set additional element attributes
        if (additionalAttrs) {
            for (const [key, value] of Object.entries(additionalAttrs)) {
                newEl.setAttribute(key, value);
            }
        }
        //insert new element after label
        currElLabel.parentNode.insertBefore(newEl, currElLabel.nextSibling);
    }

    function onServerTypeChange(serverType) {
        serverType = parseInt(serverType);
        checkGoogleServiceType();

        if (GOOGLE_SERVER_TYPES.includes(serverType)) {
            //hide auth type, encryption, server protocol,
            qs('#port').value = 993;
            qs('#encryption').value = 'SSL';
            qs('#host').value = 'imap.gmail.com';
            onProtocolChange('imap');
            qs('#protocolType').parentNode.parentNode.classList.add("invisible");
            qs('#encryption').parentNode.parentNode.classList.add("invisible");

            qs('#host').parentNode.parentNode.classList.add("invisible");
            qs('#port').parentNode.parentNode.classList.add("invisible");

            if (serverType === SERVER_TYPE_GOOGLE_SERVICE || serverType === SERVER_TYPE_GMAIL_OAUTH2) {
                qs('[name="authentication"][value="xoauth2"]').checked = true;

            } else {
                qs('[name="authentication"][value="plaintext"]').checked = true;
            }

            qs('#authentication').parentNode.parentNode.classList.add("invisible");
            qs('#isFullEmailAuth').parentNode.parentNode.parentNode.parentNode.classList.add("invisible");
            if (qs('#skipCertificateCheck')) {
                qs('#skipCertificateCheck').parentNode.parentNode.parentNode.parentNode.classList.add("invisible");
            }
        } else {
            qs('#protocolType').parentNode.parentNode.classList.remove("invisible");
            qs('#encryption').parentNode.parentNode.classList.remove("invisible");

            qs('[name="authentication"][value="plaintext"]').checked = true;
            // qs('[name="authentication"]').value = 'plaintext';
            qs('#authentication').parentNode.parentNode.classList.remove("invisible");
            qs('#isFullEmailAuth').parentNode.parentNode.parentNode.parentNode.classList.remove("invisible");
            if (qs('#skipCertificateCheck')) {
                qs('#skipCertificateCheck').parentNode.parentNode.parentNode.parentNode.classList.remove("invisible");
            }

            qs('#host').parentNode.parentNode.classList.remove("invisible");
            qs('#port').parentNode.parentNode.classList.remove("invisible");

            hideGmailHelp();
            onGlobalChange(false);

            //show global auth option
            if (qs('.hide-for-google-simple')) {
                qs('.hide-for-google-simple').classList.remove('invisible');
            }
        }

        if (serverType === SERVER_TYPE_GMAIL_OAUTH2) {
            enableWebAuth(true);
            //todo remove non-oauth2 fields
            document.querySelectorAll('#mailSyncUsers .form-row').forEach(function(rowItem) {
                if (!rowItem.querySelector('[name*="isSocial"]')) {
                    return;
                }
                if (
                    rowItem.querySelector('[name*="isSocial"]').value === 'undefined' ||
                    !rowItem.querySelector('[name*="isSocial"]').value
                ) {
                    rowItem.parentNode.removeChild(rowItem);
                }
            });
            if (syncCfg.formType === FORM_TYPE_SYNC_ONE && qs('#mailSyncUsers_0_password')) {
                qs('#mailSyncUsers_0_password').parentNode.classList.add('invisible');
            }
        } else {
            enableWebAuth(false);
            if (qs('#mailSyncUsers_0_password')) {
                qs('#mailSyncUsers_0_password').parentNode.classList.remove('invisible');
            }
        }

        if (MICROSOFT_SERVER_TYPES.includes(serverType)) {
            //or outlook.office365.com ?
            qs('#host').value = 'outlook.office365.com';
        }

        var display = MICROSOFT_SERVER_TYPES.includes(serverType) ? 'inline' : 'none';
        document.querySelectorAll('.exchange_help').forEach(function(rowItem) {
            rowItem.setAttribute('style', 'display: ' + display);
        });

        //todo finish this as not working properly
        gmailHelpToggle(qs('#originDomainName').value, qs('[name="host"]').value);
        //enable global settings so user can enter .json key
        if (serverType === SERVER_TYPE_GOOGLE_SERVICE) {
            onGlobalChange(true);
            //convert global password to textarea
            if (qs('#globalPassword')) {
                qs('label[for="globalPassword"]').textContent = syncCfg.i18n.globalPasswordGoogle;
                switchElementTagName(qs('#globalPassword'), 'textarea', {'style': 'min-height:120px;'});
                qs('#globalUsername').parentNode.parentNode.classList.add('invisible');
            }
        } else {
            onGlobalChange(false);
            //convert global password textare back to input pasword
            if (qs('#globalPassword')) {
                qs('label[for="globalPassword"]').textContent = syncCfg.i18n.globalPassword;
                switchElementTagName(qs('#globalPassword'), 'input', {'type': 'password', 'style': ''});
                qs('#globalUsername').parentNode.parentNode.classList.remove('invisible');
            }
        }

        if (
            document.querySelectorAll('div[id^="mailSyncUsers_"]').length === 0 &&
            serverType !== SERVER_TYPE_GMAIL_OAUTH2
        ) {
            addMailbox('#mailSyncUsers', null, true);
        }

        checkSubmitBtn();
        if (qs('.add-another-collection-widget')) {
            if (serverType === SERVER_TYPE_GMAIL_OAUTH2) {
                qs('.add-another-collection-widget').classList.add('d-none');
            } else {
                qs('.add-another-collection-widget').classList.remove('d-none');
            }
        }
    }

    function getServerType()
    {
        //for social it is hidden field instead of radio
        return parseInt(qs('[name="serverType"]:checked') ? qs('[name="serverType"]:checked').value : qs('[name="serverType"]').value);
    }

    setTimeout(() => {
        var serverType = getServerType();
        onServerTypeChange(serverType);
    }, 500);


    document.addEventListener('input', function (event) {
        // Only run on our select menu
        var allowedTargets = ['serverType'];
        if (!allowedTargets.includes(event.target.name)) return;
        var serverType = getServerType();
        onServerTypeChange(serverType);
    }, false);

    function onProtocolChange(newProtocol) {
        // console.log('onProtocolChange called with newProtocol='+newProtocol);
        var pop3InputDisplay = newProtocol === 'imap' ? 'none' : 'flex';
        document.querySelectorAll('.pop3-field-row').forEach(function(rowItem) {
            rowItem.setAttribute('style', 'display: ' + pop3InputDisplay + ' !important');
        });

        // //pop3 does not have folder mapping so we don't show continue to folder mapping text in submit button
        // var submitEl = qs('[name="submit"]');
        // submitEl.textContent = newProtocol === 'pop3' ? submitEl.getAttribute('data-nosync-label') : submitEl.getAttribute('data-sync-label');
    }
    //on page load:
    var protocolType = qs('[name="protocolType"]:checked') ? qs('[name="protocolType"]:checked').value : 'imap';
    onProtocolChange(protocolType);
    //on input change: auto detect and change needed port number on protocol and encryption change
    document.addEventListener('input', function (event) {
        // Only run on our select menu
        var allowedTargets = ['protocolType', 'encryption'];
        if (!allowedTargets.includes(event.target.name)) return;

        var portMapping = {
            'pop3': {
                'SSL': 995,
                'STARTTLS': 110,
                'NONE': 110,
            },
            'imap': {
                'SSL': 993,
                'STARTTLS': 143,
                'NONE': 143,
            }
        };

        var protocolType = qs('[name="protocolType"]:checked').value;

        onProtocolChange(protocolType);

        var encryption = qs('[name="encryption"]:checked') ? qs('[name="encryption"]:checked').value : 'SSL';
        var portDetected = portMapping[protocolType][encryption];

        qs('[name="port"]').value = portDetected;
    }, false);

    function onGlobalChange(isChecked) {
        // console.log('onGlobalChange called with isChecked='+isChecked);
        if (!qs('[name="useGlobalCredentials"]')) {
            return; //webmail does not have global username, password fields
        }
        if (isChecked) {
            qs('#advanced-options-collapse-content').classList.remove('collapse');
        } else {
            qs('#advanced-options-collapse-content').classList.add('collapse');
        }
        // $('#advanced-options-collapse-content').collapse(isChecked ? 'show' : 'hide');

        // if (isChecked) {
        qs('[name="useGlobalCredentials"]').checked = isChecked;
        // }
        var globalDisplay = isChecked ? 'flex' : 'none';

        var globalContainers = document.querySelectorAll('.global-credentials-wrapper');
        for(var globalContainer of globalContainers) {
            globalContainer.setAttribute('style', 'display: ' + globalDisplay + ' !important');
        }
    }

    if (qs('[name="useGlobalCredentials"]')) {
        var isGlobalChecked = qs('[name="useGlobalCredentials"]').checked;
        onGlobalChange(isGlobalChecked);
        document.addEventListener('input', function (event) {
            var allowedTargets = ['useGlobalCredentials'];
            if (!allowedTargets.includes(event.target.name)) return;
            onGlobalChange(event.target.checked);
        }, false);
    }

    //if IMAP host is google's we enable XOAuth2 and show additional help page
    function onMailHostChange(currentMailHost) {
        if (qs('#originDomainName')) {
            gmailHelpToggle(qs('#originDomainName').value, currentMailHost);
        }
    }
    document.addEventListener('input', function (event) {
        var allowedTargets = ['host'];
        if (!allowedTargets.includes(event.target.name)) return;
        // console.log('host changed to '+event.target.value);
        onMailHostChange(event.target.value);
    }, false);
    onMailHostChange(qs('[name="host"]').value);

    function onOriginDomainNameChange(newDomainName) {
        checkGoogleServiceType();

        //update placeholders
        var placeholders = document.querySelectorAll('.gl-at');
        for(var placeholder of placeholders) {
            placeholder.textContent = '@' + newDomainName;
        }
        if (qs('[name="host"]')) {
            gmailHelpToggle(newDomainName, qs('[name="host"]').value);
        }
        // //update username format full e-mail address placeholder with new domain name
        // if (qs('#usernameFormat_0')) {
        //     qs('[for="usernameFormat_0"]').textContent = qs('[for="usernameFormat_0"]').textContent.replace(/\S+\)/, 'john.doe@' + newDomainName + ')');
        // }

        syncCfg.currentDomain = newDomainName;
    }

    document.addEventListener('input', function (event) {
        var allowedTargets = ['originDomainName'];
        if (!allowedTargets.includes(event.target.name)) return;
        onOriginDomainNameChange(event.target.value);
    }, false);


    function gmailHelpToggle(currentOriginDomain, currentMailHost)
    {
        if (!qs('.gmail-help') || !qs('.gmail-personal-help')) {
            return;
        }
        //todo create help for gmail.com less secure apps
        if (currentMailHost === 'imap.gmail.com') {
            if (defaultGoogleDomains.includes(currentOriginDomain)) {
                onGlobalChange(false); //hide global username/password block

                //todo sometimes this does not work!
                qs('[name="authentication"][value="plaintext"]').checked = true;
                // qs('[name="authentication"]').value = 'plaintext';

            } else {
                var serverType = getServerType();
                const showGlobal = serverType === SERVER_TYPE_GOOGLE_SERVICE;
                onGlobalChange(showGlobal); //show global username/password block

                qs('[name="authentication"][value="xoauth2"]').checked = true;
                // qs('[name="authentication"]').value = 'xoauth2';
            }
            showGmailHelp(currentOriginDomain);
        } else {
            hideGmailHelp();
            qs('[name="authentication"][value="plaintext"]').checked = true;
            // qs('[name="authentication"]').value = 'plaintext';

        }
        onSyncTypeChange(qs('[name="mailSyncUserType"][checked="checked"],[name="mailSyncUserType"][type="hidden"]').value);
    }

    function showGmailHelp(currentOriginDomain)
    {
        if (defaultGoogleDomains.includes(currentOriginDomain)) {
            qs('.gmail-personal-help').style.display = 'block';
            qs('.gmail-help').style.display = 'none';
        } else {
            qs('.gmail-personal-help').style.display = 'none';
            qs('.gmail-help').style.display = 'block';
        }
    }

    function hideGmailHelp()
    {
        if (qs('.gmail-personal-help')) {
            qs('.gmail-personal-help').style.display = 'none';
        }
        if (qs('.gmail-help')) {
            qs('.gmail-help').style.display = 'none';
        }
    }

    //allow to edit auto-discovered incoming e-mail server settings
    document.addEventListener('click', function (event) {
        //todo this is broken. it should not be c
        var allowedTargets = ['c'];
        if (!allowedTargets.includes(event.target.name)) return;
        onOriginDomainNameChange(event.target.value);
    }, false);
    if (qs('.modify-configuration')) {
        qs('.modify-configuration').addEventListener('click', function () {
            qs('.connection-configuration').style.display = 'block';
            qs('.autodiscovered-configuration').style.display = 'none';
        });
    }

    document.addEventListener('input', function (event) {
        var allowedTargets = ['mailSyncUsersCsv'];
        if (!allowedTargets.includes(event.target.id)) return;
        if (event.target.files[0].size/1024/1024 > 1) {
            event.target.value = "";
            alert('MAX allowed size is 1MB');
        }
    }, false);

    // {# browsers remember selected option on page reload. this forces selecting original value #}
    var selects = document.querySelectorAll("select");
    for(var select of selects) {
        var options = select.querySelectorAll('option');
        for(var option of options) {
            if (option.getAttribute("selected")) {
                select.value = option.value;
            }
        }
    }

    //force select checked radio button
    var radios = document.querySelectorAll("[type=radio]");
    for(var radio of radios) {
        if (radio.checked) {
            radio.checked = true;
            radio.setAttribute('checked', 'checked');
        } else if (radio.getAttribute('checked')) {
            radio.checked = true;
        }
    }
};

export default initialize;
